import React from 'react';
import useStyle from './tableDataNav.style';
import { TableDataTab } from '../../../atoms/TableDataTab';

export type TableDataTabContent = { name: string; variant?: 'danger' };

interface TableDataNavProps {
  selected: number;
  setSelected: (tab: number) => void;
  tabs: TableDataTabContent[];
}

export const TableDataNav = ({
  selected,
  setSelected,
  tabs
}: TableDataNavProps) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      {tabs &&
        tabs.map((tab, i) => (
          <TableDataTab
            key={i}
            content={tab.name}
            onClick={() => setSelected(i)}
            selected={selected === i}
            icon={tab.variant ? 'Warning' : undefined}
            variant={tab.variant}
          />
        ))}
    </div>
  );
};
